import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import DatePicker from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./styles";
class SelectDateTime extends Component {
  renderMonth = (props, month, year, selectedDate) => {
    return <td {...props}>{month + 1}</td>;
  };
  render() {
    const {
      fullWidth = true,
      className,
      label,
      value,
      margin = "none",
      dateFormat = "DD/MM/YYYY",
      name,
      disabled = false,
      onChange,
      InputProps = {},
      InputLabelProps = {},
      required = false,
      i18n,
      serviceSetting,
    } = this.props;
    let formatDatetime = serviceSetting.formatDatetime || "24h";

    return (
      <DatePicker
        renderInput={(props) => (
          <TextField
            required={required}
            variant="outlined"
            InputProps={{
              ...InputProps,
            }}
            InputLabelProps={{
              ...InputLabelProps,
            }}
            label={label}
            fullWidth={fullWidth}
            margin={margin}
            disabled={disabled}
            value={value}
            {...props}
          />
        )}
        fullWidth={fullWidth}
        className={className}
        disabled={disabled}
        name={name}
        label={label}
        value={moment(value)}
        onChange={onChange}
        timeFormat={formatDatetime === "24h" ? "HH:mm" : "hh:mm A"}
        dateFormat={dateFormat}
        renderMonth={this.renderMonth}
        locale={i18n.language === "vn" ? "vi" : "en"}
      />
    );
  }
}

SelectDateTime.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceSetting: state.serviceSetting.serviceSetting,
});

const mapDispatch = (dispatch) => ({});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SelectDateTime)
  )
);
